// src/features/works/WorkForm.jsx - Versión corregida
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, Spinner } from 'react-bootstrap';
import { FaSave, FaTimes, FaArrowLeft } from 'react-icons/fa';
import dayjs from 'dayjs';
import { useNavigationHistory } from '../../hooks/useNavigationHistory';


 
// Servicios y componentes
import WorksService from './WorksService';
import CustomSnackbar from '../../components/CustomSnackbar';
import PeopleService from '../people/PeopleService';

/**
 * Componente de formulario para crear o editar obras
 */
function WorkForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false); // Estado separado para carga inicial
  const [loadingClients, setLoadingClients] = useState(false);
  const [clients, setClients] = useState([]);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, type: '', message: '' });
   const { goBack } = useNavigationHistory();
  // Estado del formulario
  const [formData, setFormData] = useState({
    name: '',
    startDate: dayjs().format('YYYY-MM-DD'),
    endDate: '',
    location: '',
    observations: '',
    personsIds: [],
    deletedDate: null
  });

  // Departamentos de Uruguay para el select
  const departments = [
    { id: 'Montevideo', nombre: 'Montevideo' },
    { id: 'Artigas', nombre: 'Artigas' },
    { id: 'Canelones', nombre: 'Canelones' },
    { id: 'Cerro Largo', nombre: 'Cerro Largo' },
    { id: 'Colonia', nombre: 'Colonia' },
    { id: 'Durazno', nombre: 'Durazno' },
    { id: 'Flores', nombre: 'Flores' },
    { id: 'Florida', nombre: 'Florida' },
    { id: 'Lavalleja', nombre: 'Lavalleja' },
    { id: 'Maldonado', nombre: 'Maldonado' },
    { id: 'Paysandú', nombre: 'Paysandú' },
    { id: 'Río Negro', nombre: 'Río Negro' },
    { id: 'Rivera', nombre: 'Rivera' },
    { id: 'Rocha', nombre: 'Rocha' },
    { id: 'Salto', nombre: 'Salto' },
    { id: 'San José', nombre: 'San José' },
    { id: 'Soriano', nombre: 'Soriano' },
    { id: 'Tacuarembó', nombre: 'Tacuarembó' },
    { id: 'Treinta y Tres', nombre: 'Treinta y Tres' }
  ];

  // Cargar datos de obra si estamos en modo edición
  useEffect(() => {
    if (id) {
      loadWork(id);
    }
    
    // Cargar lista de clientes
    loadClients();
  }, [id]);

  // Cargar datos de la obra
  const loadWork = async (workId) => {
    try {
      setLoadingData(true); // Usar estado separado para carga inicial
      const workData = await WorksService.getWork(workId);
      
      // Formatear fecha para el input de tipo date
      setFormData({
        ...workData,
        startDate: workData.startDate ? dayjs(workData.startDate).format('YYYY-MM-DD') : '',
        endDate: workData.endDate ? dayjs(workData.endDate).format('YYYY-MM-DD') : '',
        personsIds: workData.customers && workData.customers.length > 0 
          ? [workData.customers[0].id] 
          : []
      });
    } catch (error) {
      console.error('Error al cargar los datos de la obra:', error);
      setSnackbar({
        open: true,
        type: 'error',
        message: 'Error al cargar los datos de la obra'
      });
    } finally {
      setLoadingData(false);
    }
  };

  // Cargar lista de clientes (personas jurídicas)
  const loadClients = async () => {
    try {
      setLoadingClients(true);
      // Usamos el servicio de personas para obtener los clientes
      // En un entorno real, esto podría ser un endpoint específico
      const allPeople = await PeopleService.getAllPeople();
      
      // Filtramos para obtener solo clientes (personas jurídicas)
      const clientsList = allPeople.filter(person => 
        person.type === 'J' && person.regime === 'Cliente'
      );
      
      setClients(clientsList);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      setSnackbar({
        open: true,
        type: 'error',
        message: 'Error al cargar la lista de clientes'
      });
    } finally {
      setLoadingClients(false);
    }
  };

  // Manejar cambios en inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar errores al modificar un campo
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  // Manejar selección de cliente
  const handleClientChange = (e) => {
    const clientId = e.target.value;
    setFormData(prev => ({
      ...prev,
      personsIds: clientId ? [clientId] : []
    }));
    
    // Limpiar error de cliente
    if (errors.client) {
      setErrors(prev => ({ ...prev, client: false }));
    }
  };

  // Manejar cambio de estado (activo/finalizado)
  const handleStatusChange = (e) => {
    const isFinalized = e.target.value === 'false';
    
    setFormData(prev => ({
      ...prev,
      deletedDate: isFinalized ? dayjs().format() : null
    }));
  };

  // Validar formulario
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = true;
    if (!formData.startDate) newErrors.startDate = true;
    if (!formData.location) newErrors.location = true;
    if (formData.personsIds.length === 0) newErrors.client = true;
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Enviar formulario - VERSIÓN CORREGIDA
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ✅ BLOQUEO INMEDIATO - Esta es la clave para prevenir doble envío
    if (loading) {
      console.warn('Ya se está enviando, ignorando clic');
      return;
    }
    
    if (!validateForm()) {
      setSnackbar({
        open: true,
        type: 'error',
        message: 'Por favor complete todos los campos requeridos'
      });
      return;
    }
    
    try {
      // ✅ Bloquear INMEDIATAMENTE antes de cualquier operación async
      setLoading(true);
      
      // Datos a enviar
      const workDataToSend = {
        ...formData,
        // Convertir fechas al formato esperado por la API
        startDate: dayjs(formData.startDate).format('YYYY-MM-DD'),
        endDate: formData.endDate ? dayjs(formData.endDate).format('YYYY-MM-DD') : null
      };
      
      if (id) {
        // Actualizar obra existente
        const result = await WorksService.updateWork(id, workDataToSend);
        
        if (result.statusCode >= 400) {
          throw new Error(result.data.message || 'Error al actualizar la obra');
        }
        
        setSnackbar({
          open: true,
          type: 'success',
          message: 'Obra actualizada correctamente'
        });
      } else {
        // Crear nueva obra
        await WorksService.createWork(workDataToSend);
        setSnackbar({
          open: true,
          type: 'success',
          message: 'Obra creada correctamente'
        });
      }
      
      // Redireccionar después de mostrar el mensaje
      setTimeout(() => {
        navigate('/works');
      }, 1500);
      
    } catch (error) {
      console.error('Error al guardar la obra:', error);
      setSnackbar({
        open: true,
        type: 'error',
        message: `Error al ${id ? 'actualizar' : 'crear'} la obra: ${error.message}`
      });
      
      // ✅ IMPORTANTE: Solo resetear loading en caso de error
      setLoading(false);
    }
    // Nota: NO reseteamos loading en caso de éxito porque redirigimos
  };



  // Mostrar spinner si está cargando datos iniciales
  if (loadingData) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container fluid className="my-3">
      <Card>
        <Card.Header className="bg-primary text-white text-center">
          <h5 className="m-0">{id ? 'Editar' : 'Crear nueva'} Obra</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre de la Obra*</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    isInvalid={errors.name}
                    disabled={loading}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    El nombre de la obra es requerido
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha de Inicio*</Form.Label>
                  <Form.Control
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                    isInvalid={errors.startDate}
                    disabled={loading}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    La fecha de inicio es requerida
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Ubicación*</Form.Label>
                  <Form.Select
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    isInvalid={errors.location}
                    disabled={loading}
                    required
                  >
                    <option value="">Seleccione un departamento</option>
                    {departments.map(dept => (
                      <option key={dept.id} value={dept.nombre}>
                        {dept.nombre}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    La ubicación es requerida
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cliente*</Form.Label>
                  <Form.Select
                    name="client"
                    value={formData.personsIds[0] || ''}
                    onChange={handleClientChange}
                    isInvalid={errors.client}
                    disabled={loading || loadingClients}
                    required
                  >
                    <option value="">Seleccione un cliente</option>
                    {loadingClients ? (
                      <option disabled>Cargando clientes...</option>
                    ) : (
                      clients.map(client => (
                        <option key={client.id} value={client.id}>
                          {client.businessName || `${client.firstName} ${client.lastName}`}
                        </option>
                      ))
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Debe seleccionar un cliente
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha de Fin</Form.Label>
                  <Form.Control
                    type="date"
                    name="endDate"
                    value={formData.endDate || ''}
                    onChange={handleInputChange}
                    disabled={loading}
                  />
                  <Form.Text className="text-muted">
                    Opcional. Dejar vacío para obras en curso.
                  </Form.Text>
                </Form.Group>
              </Col>
              
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Estado</Form.Label>
                  <Form.Select
                    name="status"
                    value={formData.deletedDate === null ? 'true' : 'false'}
                    onChange={handleStatusChange}
                    disabled={loading || !id}
                  >
                    <option value="true">Activa</option>
                    <option value="false">Finalizada</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Observaciones</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="observations"
                    value={formData.observations || ''}
                    onChange={handleInputChange}
                    disabled={loading}
                    placeholder="Ingrese observaciones adicionales (opcional)"
                  />
                </Form.Group>
              </Col>
            </Row>
            
            <div className="d-flex justify-content-end mt-3">
              <Button
                variant="secondary"
                onClick={goBack}
                className="me-2"
                disabled={loading}
                type="button"
              >
                <FaTimes className="me-1" /> Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={loading} // ✅ BLOQUEO SIMPLE Y EFECTIVO
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                    Guardando...
                  </>
                ) : (
                  <>
                    <FaSave className="me-1" /> {id ? 'Actualizar' : 'Crear'} Obra
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      
      <CustomSnackbar
        open={snackbar.open}
        type={snackbar.type}
        message={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Container>
  );
}

export default WorkForm;